import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";

@Component({
	selector: 'app-main-index',
	imports: [
		RouterOutlet,
		MatFormFieldModule,
		MatSelectModule
	],
	templateUrl: './main-index.component.html',
	styleUrl: './main-index.component.scss'
})
export class MainIndexComponent {

}
